<template>
    <div class="address-group">
        <slot>
            <addr></addr>
        </slot>
    </div>
</template>
<script>
    import addr from './Address.vue'

    export default {
        components: {
            addr
        }
    }
</script>
<style></style>



// WEBPACK FOOTER //
// AddressGroup.vue?bad3a6cc